import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'
import { printEngagementLetter } from '@/utilities/print-engagement-letter'

export const EngagementLetterActions = {
  async loadEngagementLetterSession ({ commit }, token) {
    return axiosRequest.
      get(`/engagement_letters/${token}`).
      then(({ data }) => commit('setEngagementLetterSession', data)).
      catch(handleError)
  },

  async printEngagementLetter ({ state, rootGetters }) {
    printEngagementLetter({
      ...state.legalCase,
      legalCaseTypeTitle: rootGetters.legalCaseTypesIds[state.legalCase.legal_case_type_id]?.fullName ?? '',
    })
  },

  async mailEngagementLetter ({ commit, state }, legalCaseId) {
    return axiosRequest.
      patch(`/legal_cases/${legalCaseId}/engagement_letters/mail`, state.legalCaseEdit.edited).
      then(({ data }) => commit('setLegalCase', data)).
      catch(handleError)
  },

  async updateEngagementSession ({ commit, state }) {
    return axiosRequest.
      patch(`/engagement_letters/${state.engagementLetterSession.engagement_letter_token}`, state.engagementLetterSession).
      then(({ data }) => commit('setEngagementLetterSession', data)).
      catch(handleError)
  },
}

export const EngagementLetterGetters = {
  engagementLetterSession: state => state.engagementLetterSession,
}

export const EngagementLetterMutations = {
  setEngagementLetterSession (state, value) { state.engagementLetterSession = value },
}

export const EngagementLetterState = {
  engagementLetterSession: {},
}
